import {
  ObjectTypeInfoColumnViewModel,
  ObjectTypeInfoReferenceViewModel,
  ObjectTypeInfoReferencingViewModel,
  ObjectTypeInfoViewModel,
} from '@barthauer/abc/core/data';

export class SelectedEntity {
  public id: string;
  public mainObjectTypeInfoViewModel: ObjectTypeInfoViewModel;
  public objectInfo:
    | ObjectTypeInfoColumnViewModel
    | ObjectTypeInfoReferenceViewModel
    | ObjectTypeInfoReferencingViewModel;
  public parentObjectInfo:
    | ObjectTypeInfoColumnViewModel
    | ObjectTypeInfoReferenceViewModel
    | ObjectTypeInfoReferencingViewModel;
  public isCTRLKeyHold: boolean;
  public isReferencing: boolean;

  constructor() {
    //
  }
}

export enum EntityButtonId {
  pinnedBtn = 0,
  keyBtn = 1,
  preferenceBtn = 2,
}
